import { render, staticRenderFns } from "./Price1024.vue?vue&type=template&id=cabda2f8&scoped=true"
import script from "./Price1024.vue?vue&type=script&lang=js"
export * from "./Price1024.vue?vue&type=script&lang=js"
import style0 from "./Price1024.vue?vue&type=style&index=0&id=cabda2f8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabda2f8",
  null
  
)

export default component.exports